/* Asteric — Drop Verão
   Comportamento das páginas de coleção e produto do drop. */
(() => {
  if (window.__dvLoaded) return;
  window.__dvLoaded = true;

  const mqMobile = window.matchMedia('(max-width: 1099px)');

  const store = {
    get(key) { try { return localStorage.getItem(key); } catch (e) { return null; } },
    set(key, value) { try { localStorage.setItem(key, value); } catch (e) {} },
  };

  const money = (cents) => {
    const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'BRL';
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency }).format(cents / 100);
  };

  const haptic = () => { if (navigator.vibrate) navigator.vibrate(12); };

  let scrollLocks = 0;
  const lockScroll = (on) => {
    scrollLocks = Math.max(0, scrollLocks + (on ? 1 : -1));
    document.documentElement.style.overflow = scrollLocks ? 'hidden' : '';
  };

  /* ---------- Carrinho ---------- */

  async function addToCart(variantId, quantity = 1) {
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    const res = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity }] }),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message || 'Não foi possível adicionar.');
    haptic();
    return data;
  }

  // Abre o carrinho lateral do tema Distinctive (ou vai para /cart).
  function openCart() {
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    const toggle = document.getElementById('cart-drawer-toggle');
    if (toggle) setTimeout(() => toggle.click(), 200);
    else window.location.href = '/cart';
  }

  /* ---------- Revelar ao rolar ---------- */

  const revealObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -6% 0px' })
    : null;

  function initReveal(scope) {
    scope.querySelectorAll('.dv-reveal:not(.is-in)').forEach((el) => {
      if (revealObserver) revealObserver.observe(el);
      else el.classList.add('is-in');
    });
  }

  /* ---------- Fotos deslizáveis dentro do card ---------- */

  function initCardTracks(scope) {
    scope.querySelectorAll('[data-dv-track]:not([data-ready])').forEach((track) => {
      track.dataset.ready = '1';
      const dots = track.parentElement.querySelectorAll('.dv-card__dots i');
      if (!dots.length) return;
      let raf;
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const i = Math.round(track.scrollLeft / track.clientWidth);
          dots.forEach((d, j) => d.classList.toggle('is-active', i === j));
        });
      }, { passive: true });
    });
  }

  /* ---------- Gaveta de tamanhos (bottom sheet) ---------- */

  function sheetFor(root) {
    const sheet = root.querySelector('[data-dv-sheet]');
    if (!sheet) return null;
    const titleEl = sheet.querySelector('[data-dv-sheet-title]');
    const priceEl = sheet.querySelector('[data-dv-sheet-price]');
    const sizesEl = sheet.querySelector('[data-dv-sheet-sizes]');
    const statusEl = sheet.querySelector('[data-dv-sheet-status]');
    const guideBtn = sheet.querySelector('[data-dv-sheet-guide]');
    let onPick = null;
    let lastFocus = null;

    const close = () => {
      if (sheet.hidden) return;
      sheet.classList.add('is-closing');
      setTimeout(() => {
        sheet.hidden = true;
        sheet.classList.remove('is-closing');
        lockScroll(false);
        if (lastFocus) lastFocus.focus({ preventScroll: true });
      }, 240);
    };

    // options: { title, price, sizes: [{id, label, available}], guideId, onPick(size, button) }
    const open = (options) => {
      lastFocus = document.activeElement;
      titleEl.textContent = options.title;
      priceEl.textContent = options.price || '';
      statusEl.textContent = '';
      sizesEl.innerHTML = '';
      options.sizes.forEach((size) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.textContent = size.label;
        b.disabled = !size.available;
        if (!size.available) b.setAttribute('aria-label', `${size.label} esgotado`);
        b.addEventListener('click', () => onPick && onPick(size, b));
        sizesEl.appendChild(b);
      });
      guideBtn.hidden = !options.guideId;
      if (options.guideId) guideBtn.dataset.dvOpen = options.guideId;
      onPick = options.onPick;
      sheet.hidden = false;
      lockScroll(true);
      const first = sizesEl.querySelector('button:not(:disabled)');
      if (first) first.focus({ preventScroll: true });
    };

    sheet.addEventListener('click', (e) => {
      if (e.target.closest('[data-dv-sheet-close]')) close();
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });

    // Arrastar para baixo fecha
    const panel = sheet.querySelector('.dv-sheet__panel');
    let startY = null;
    panel.addEventListener('touchstart', (e) => { startY = e.touches[0].clientY; }, { passive: true });
    panel.addEventListener('touchmove', (e) => {
      if (startY === null) return;
      const dy = Math.max(0, e.touches[0].clientY - startY);
      panel.style.transform = `translateY(${dy}px)`;
    }, { passive: true });
    panel.addEventListener('touchend', (e) => {
      const dy = e.changedTouches[0].clientY - (startY || 0);
      panel.style.transform = '';
      startY = null;
      if (dy > 90) close();
    });

    return { open, close, status: (t) => { statusEl.textContent = t; } };
  }

  // Fluxo "escolhe tamanho → adiciona → abre carrinho"
  async function pickAndAdd(sheet, size, button) {
    if (button.classList.contains('is-loading')) return;
    button.classList.add('is-loading');
    sheet.status('Adicionando…');
    try {
      await addToCart(size.id);
      button.classList.remove('is-loading');
      button.classList.add('is-done');
      sheet.status(`Tamanho ${size.label} adicionado ✓`);
      setTimeout(() => { sheet.close(); openCart(); }, 550);
    } catch (err) {
      button.classList.remove('is-loading');
      sheet.status(err.message);
    }
  }

  /* ---------- Adicionar rápido nos cards ---------- */

  function initQuickAdd(root, sheet) {
    root.addEventListener('click', async (e) => {
      // Botão "+" (celular) → gaveta de tamanhos
      const plus = e.target.closest('[data-dv-quick]');
      if (plus && sheet) {
        e.preventDefault();
        const sizes = plus.dataset.dvQuick.split('^').map((row) => {
          const [id, label, available] = row.split('~');
          return { id, label, available: available === 'true' };
        });
        sheet.open({
          title: plus.dataset.dvQuickTitle,
          price: plus.dataset.dvQuickPrice,
          sizes,
          onPick: (size, b) => pickAndAdd(sheet, size, b),
        });
        return;
      }

      // Tamanhos sobre a foto (desktop) → adiciona direto
      const btn = e.target.closest('.dv-card__sizes [data-dv-add]');
      if (!btn || btn.disabled) return;
      e.preventDefault();
      const original = btn.textContent;
      btn.textContent = '…';
      try {
        await addToCart(btn.dataset.dvAdd);
        btn.textContent = '✓';
        btn.classList.add('is-done');
        openCart();
      } catch (err) {
        btn.textContent = '✕';
      }
      setTimeout(() => { btn.textContent = original; btn.classList.remove('is-done'); }, 1600);
    });
  }

  /* ---------- Título gigante do hero sempre cabe na largura ---------- */

  function fitHeroTitle(root) {
    const title = root.querySelector('.dv-hero__title');
    if (!title) return;
    const span = title.querySelector('span');
    const fit = () => {
      title.style.fontSize = '';
      const max = parseFloat(getComputedStyle(title).fontSize);
      const available = title.clientWidth;
      const width = span.scrollWidth;
      if (width > available) title.style.fontSize = `${Math.floor(max * (available / width) * 0.98)}px`;
    };
    fit();
    if (document.fonts) document.fonts.ready.then(fit);
    let w = window.innerWidth;
    window.addEventListener('resize', () => {
      if (window.innerWidth !== w) { w = window.innerWidth; fit(); }
    }, { passive: true });
  }

  /* ---------- Coleção ---------- */

  function initCollection(root) {
    const grid = root.querySelector('[data-dv-grid]');
    if (!grid) return;
    let activeType = 'all';

    // Fotos grandes / pequenas (lembrado no navegador)
    const densityButtons = root.querySelectorAll('[data-dv-density]');
    const setDensity = (value) => {
      grid.dataset.density = value;
      densityButtons.forEach((b) => b.classList.toggle('is-active', b.dataset.dvDensity === value));
      store.set('dv-density', value);
    };
    const saved = store.get('dv-density');
    if (saved === 'lg' || saved === 'sm') setDensity(saved);
    densityButtons.forEach((b) => b.addEventListener('click', () => setDensity(b.dataset.dvDensity)));

    // Filtro por tipo
    const countEl = root.querySelector('[data-dv-count]');
    const totalText = countEl ? countEl.textContent : '';
    const applyFilter = () => {
      let visible = 0;
      grid.querySelectorAll('.dv-card').forEach((card) => {
        const show = activeType === 'all' || card.dataset.dvType === activeType;
        card.hidden = !show;
        if (show) visible += 1;
      });
      grid.querySelectorAll('[data-dv-editorial]').forEach((ed) => { ed.hidden = activeType !== 'all'; });
      if (countEl) countEl.textContent = activeType === 'all' ? totalText : visible;
    };
    const chips = root.querySelectorAll('[data-dv-filter]');
    chips.forEach((chip) => chip.addEventListener('click', () => {
      activeType = chip.dataset.dvFilter;
      chips.forEach((c) => c.classList.toggle('is-active', c === chip));
      chip.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      applyFilter();
      const bar = root.querySelector('.dv-toolbar');
      if (bar && bar.getBoundingClientRect().top < 0) bar.scrollIntoView({ behavior: 'smooth' });
    }));

    // Ordenar
    const sort = root.querySelector('[data-dv-sort]');
    if (sort) sort.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      url.hash = root.querySelector('.dv-toolbar').id;
      window.location.href = url.toString();
    });

    // Carregar mais (sem recarregar a página)
    const more = root.querySelector('[data-dv-more]');
    if (more) {
      const shownEl = root.querySelector('[data-dv-shown]');
      const moreText = more.querySelector('span') || more;
      const moreLabel = moreText.textContent;
      more.addEventListener('click', async (e) => {
        e.preventDefault();
        more.classList.add('is-loading');
        moreText.textContent = 'Carregando…';
        try {
          const html = await (await fetch(more.href)).text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const nextGrid = doc.querySelector('[data-dv-grid]');
          const nextMore = doc.querySelector('[data-dv-more]');
          const nextShown = doc.querySelector('[data-dv-shown]');
          [...nextGrid.children].forEach((child) => grid.appendChild(child));
          initReveal(grid);
          initCardTracks(grid);
          applyFilter();
          if (shownEl && nextShown) shownEl.textContent = nextShown.textContent;
          if (nextMore) {
            more.href = nextMore.href;
            moreText.textContent = moreLabel;
            more.classList.remove('is-loading');
          } else {
            more.closest('.dv-more').remove();
          }
        } catch (err) {
          window.location.href = more.href;
        }
      });
    }
  }

  /* ---------- Produto ---------- */

  function initProduct(root, sheet) {
    const form = root.querySelector('[data-dv-form]');
    if (!form) return;

    const variants = JSON.parse(root.querySelector('[data-dv-variants]').textContent);
    let stockMap = {};
    try { stockMap = JSON.parse(root.querySelector('[data-dv-stock-map]').textContent); } catch (e) {}
    const lowStock = Number(root.dataset.dvLowStock || 3);

    const idInput = form.querySelector('[data-dv-variant-id]');
    const addBtn = form.querySelector('[data-dv-add-main]');
    const addLabel = form.querySelector('[data-dv-add-label]');
    const errorEl = form.querySelector('[data-dv-error]');
    const stockEl = form.querySelector('[data-dv-stock]');
    const sizeFs = form.querySelector('[data-dv-size-option]');
    const sizeHint = form.querySelector('[data-dv-size-hint]');
    const fieldsets = [...form.querySelectorAll('[data-dv-option]')];
    const sizeIndex = sizeFs ? Number(sizeFs.dataset.dvOption) : -1;
    const sticky = root.querySelector('[data-dv-sticky]');
    const stickyPrice = root.querySelector('[data-dv-sticky-price]');
    const stickyAdd = root.querySelector('[data-dv-sticky-add]');
    const stickyLabel = root.querySelector('[data-dv-sticky-label]');
    const gallery = root.querySelector('[data-dv-gallery]');
    const guideId = root.querySelector('[data-dv-drawer]')?.id;

    const labels = {
      add: root.dataset.dvAddLabel || 'Adicionar à sacola',
      choose: root.dataset.dvChooseLabel || 'Escolher tamanho',
    };

    const selected = () => fieldsets.map((fs) => {
      const checked = fs.querySelector('input:checked');
      return checked ? checked.value : null;
    });

    const findVariant = (combo) => variants.find((v) => v.options.every((o, i) => o === combo[i]));

    // Risca tamanhos/cores sem estoque para a combinação atual
    const markAvailability = () => {
      const current = selected();
      fieldsets.forEach((fs, i) => {
        fs.querySelectorAll('input').forEach((input) => {
          const combo = [...current];
          combo[i] = input.value;
          const match = variants.find((v) => v.options.every((o, j) => combo[j] === null || o === combo[j]));
          input.closest('.dv-pill').classList.toggle('is-unavailable', !match || !match.available);
        });
        const label = fs.querySelector('[data-dv-option-label]');
        if (label) label.textContent = current[i] || '';
      });
    };

    const setButtons = (text, disabled) => {
      addLabel.textContent = text;
      addBtn.disabled = disabled;
      if (stickyLabel) stickyLabel.textContent = text;
      if (stickyAdd) stickyAdd.disabled = disabled;
    };

    const renderPrice = (variant) => {
      root.querySelectorAll('[data-dv-price-now]').forEach((el) => { el.textContent = money(variant.price); });
      if (stickyPrice) stickyPrice.textContent = money(variant.price);
      const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      root.querySelectorAll('[data-dv-price-was]').forEach((el) => {
        el.hidden = !onSale;
        if (onSale) el.textContent = money(variant.compare_at_price);
      });
      root.querySelectorAll('[data-dv-price-off]').forEach((el) => {
        el.hidden = !onSale;
        if (onSale) el.textContent = `-${Math.floor(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price)}%`;
      });
      root.querySelectorAll('[data-dv-installments]').forEach((el) => {
        const n = Number(el.dataset.count);
        el.textContent = `ou ${n}x de ${money(Math.floor(variant.price / n))}${el.dataset.suffix ? ` ${el.dataset.suffix}` : ''}`;
      });
    };

    const renderStock = (variant) => {
      if (!stockEl) return;
      const qty = variant ? stockMap[variant.id] : null;
      const show = lowStock > 0 && variant && variant.available && qty !== null && qty !== undefined && qty > 0 && qty <= lowStock;
      stockEl.hidden = !show;
      if (show) stockEl.textContent = qty === 1 ? 'Última unidade neste tamanho' : `Restam só ${qty} neste tamanho`;
    };

    const goToMedia = (variant) => {
      if (!variant || !variant.featured_media || !gallery) return;
      const fig = gallery.querySelector(`[data-media-id="${variant.featured_media.id}"]`);
      if (!fig) return;
      if (mqMobile.matches) gallery.scrollTo({ left: fig.offsetLeft, behavior: 'smooth' });
      else if (fig !== gallery.firstElementChild) gallery.prepend(fig);
    };

    const update = (fromUser) => {
      const current = selected();
      const variant = current.every((v) => v !== null) ? findVariant(current) : null;
      errorEl.hidden = true;
      if (sizeFs) sizeFs.classList.remove('is-missing');
      if (sizeHint) sizeHint.hidden = true;

      if (!variant) {
        idInput.value = '';
        const missingSize = sizeIndex >= 0 && current[sizeIndex] === null;
        setButtons(missingSize ? labels.choose : 'Indisponível', !missingSize);
        renderStock(null);
        markAvailability();
        return null;
      }

      idInput.value = variant.id;
      setButtons(variant.available ? labels.add : 'Esgotado', !variant.available);
      renderPrice(variant);
      renderStock(variant);
      if (fromUser) goToMedia(variant);

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
      markAvailability();
      return variant;
    };

    form.addEventListener('change', (e) => {
      if (e.target.matches('[data-dv-option] input')) update(true);
    });
    update(false);

    const flagMissingSize = () => {
      if (!sizeFs) return;
      sizeFs.classList.remove('is-missing');
      void sizeFs.offsetWidth;
      sizeFs.classList.add('is-missing');
      if (sizeHint) sizeHint.hidden = false;
      haptic();
    };

    const submit = async () => {
      if (!idInput.value) {
        // Sem tamanho escolhido: no celular abre a gaveta; no computador destaca o campo
        if (mqMobile.matches && sheet && sizeIndex >= 0 && fieldsets.length === 1) openSizeSheet();
        else { flagMissingSize(); sizeFs?.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
        return;
      }
      addBtn.classList.add('is-loading');
      try {
        await addToCart(idInput.value);
        addBtn.classList.remove('is-loading');
        addBtn.classList.add('is-done');
        addLabel.textContent = 'Adicionado ✓';
        openCart();
        setTimeout(() => {
          addBtn.classList.remove('is-done');
          update(false);
        }, 1800);
      } catch (err) {
        addBtn.classList.remove('is-loading');
        errorEl.textContent = err.message;
        errorEl.hidden = false;
      }
    };

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      if (addBtn.disabled && idInput.value) return;
      submit();
    });

    // Gaveta com os tamanhos (produto com uma opção só)
    const openSizeSheet = () => {
      const inputs = [...sizeFs.querySelectorAll('input')];
      sheet.open({
        title: root.querySelector('.dv-product__title').textContent.trim(),
        price: root.querySelector('[data-dv-price-now]').textContent,
        guideId,
        sizes: inputs.map((input) => {
          const v = findVariant([input.value]);
          return { id: v ? v.id : null, label: input.value, available: !!(v && v.available), input };
        }),
        onPick: (size, b) => {
          size.input.checked = true;
          update(false);
          pickAndAdd(sheet, size, b);
        },
      });
    };

    // Barra fixa: aparece quando o botão principal sai da tela
    if (sticky && stickyAdd) {
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(([entry]) => {
          sticky.classList.toggle('is-visible', !entry.isIntersecting);
        }, { rootMargin: '0px 0px -40px 0px' }).observe(addBtn);
      }
      stickyAdd.addEventListener('click', () => {
        if (!idInput.value && !(sheet && sizeIndex >= 0 && fieldsets.length === 1)) {
          fieldsets.find((fs) => !fs.querySelector('input:checked'))?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          flagMissingSize();
          return;
        }
        submit();
      });
    }

    // Galeria: contador e pontinhos (celular)
    const dots = root.querySelectorAll('[data-dv-dots] i');
    const current = root.querySelector('[data-dv-gallery-current]');
    if (gallery && dots.length) {
      let raf;
      gallery.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const i = Math.round(gallery.scrollLeft / gallery.clientWidth);
          dots.forEach((d, j) => d.classList.toggle('is-active', i === j));
          if (current) current.textContent = i + 1;
        });
      }, { passive: true });
    }

    initViewer(root);
  }

  /* ---------- Fotos em tela cheia ---------- */

  function initViewer(root) {
    const viewer = root.querySelector('[data-dv-viewer]');
    const gallery = root.querySelector('[data-dv-gallery]');
    if (!viewer || !gallery) return;
    const track = viewer.querySelector('[data-dv-viewer-track]');
    const counter = viewer.querySelector('[data-dv-viewer-counter]');

    const open = (index) => {
      const imgs = [...gallery.querySelectorAll('.dv-gallery__zoom img')];
      track.innerHTML = imgs.map((img) => `<div class="dv-viewer__slide"><img src="${img.dataset.full || img.currentSrc || img.src}" alt="${img.alt || ''}"></div>`).join('');
      viewer.hidden = false;
      lockScroll(true);
      const total = imgs.length;
      const setCount = () => { counter.textContent = `${Math.round(track.scrollLeft / track.clientWidth) + 1}/${total}`; };
      requestAnimationFrame(() => {
        track.scrollLeft = track.clientWidth * index;
        setCount();
      });
      track.onscroll = setCount;
    };

    const close = () => {
      if (viewer.hidden) return;
      viewer.hidden = true;
      track.innerHTML = '';
      lockScroll(false);
    };

    gallery.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-dv-zoom-open]');
      if (!btn) return;
      const imgs = [...gallery.querySelectorAll('.dv-gallery__zoom')];
      open(Math.max(0, imgs.indexOf(btn)));
    });
    viewer.querySelector('[data-dv-viewer-close]').addEventListener('click', close);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
  }

  /* ---------- Tabela de medidas ---------- */

  function initGuide(root) {
    const guide = root.querySelector('[data-dv-drawer]');
    const form = root.querySelector('[data-dv-form]');
    if (!guide) return;
    const rows = [...guide.querySelectorAll('tr[data-size]')];
    const pick = guide.querySelector('[data-dv-guide-pick]');
    const pickLabel = guide.querySelector('[data-dv-guide-pick-label]');
    const sizeInputs = form ? [...form.querySelectorAll('[data-dv-size-option] input')] : [];
    const norm = (t) => String(t).trim().toUpperCase();
    const inputFor = (size) => sizeInputs.find((i) => norm(i.value) === norm(size));
    let chosen = null;

    const highlight = (size) => {
      chosen = size;
      rows.forEach((r) => r.classList.toggle('is-active', size !== null && norm(r.dataset.size) === norm(size)));
      if (!pick) return;
      const input = size ? inputFor(size) : null;
      const unavailable = input && input.closest('.dv-pill').classList.contains('is-unavailable');
      pick.disabled = !input || unavailable;
      pickLabel.textContent = !size ? 'Toque num tamanho da tabela'
        : !input ? `Tamanho ${size} não disponível`
        : unavailable ? `Tamanho ${size} esgotado`
        : `Escolher tamanho ${size}`;
    };

    rows.forEach((row) => row.addEventListener('click', () => { highlight(row.dataset.size); haptic(); }));

    // Ao abrir, marca o tamanho que o cliente já escolheu
    guide.addEventListener('dv:open', () => {
      const checked = sizeInputs.find((i) => i.checked);
      highlight(checked ? checked.value : null);
    });

    if (pick) pick.addEventListener('click', () => {
      const input = chosen && inputFor(chosen);
      if (!input) return;
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      guide.hidden = true;
      lockScroll(false);
      form.querySelector('[data-dv-add-main]')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  /* ---------- Rolagem suave para âncoras (ex.: botão do hero) ---------- */

  function initScrollLinks() {
    document.addEventListener('click', (e) => {
      const link = e.target.closest('a[data-dv-scroll]');
      if (!link) return;
      const hash = link.getAttribute('href');
      if (!hash || !hash.startsWith('#')) return;
      const target = document.querySelector(hash);
      if (!target) return;
      e.preventDefault();
      const header = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
      window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - header + 1, behavior: 'smooth' });
    });
  }

  /* ---------- Gavetas ---------- */

  function initDrawers(root) {
    document.addEventListener('click', (e) => {
      const opener = e.target.closest('[data-dv-open]');
      if (opener && root.contains(opener)) {
        const drawer = document.getElementById(opener.dataset.dvOpen);
        if (drawer) {
          drawer.hidden = false;
          lockScroll(true);
          drawer.dispatchEvent(new CustomEvent('dv:open'));
          drawer.querySelector('[data-dv-close]')?.focus();
        }
        return;
      }
      const drawer = e.target.closest('[data-dv-drawer]');
      if (drawer && root.contains(drawer) && (e.target === drawer || e.target.closest('[data-dv-close]'))) {
        drawer.hidden = true;
        lockScroll(false);
      }
    });
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      root.querySelectorAll('[data-dv-drawer]:not([hidden])').forEach((d) => {
        d.hidden = true;
        lockScroll(false);
      });
    });
  }

  /* ---------- Início ---------- */

  function init(root) {
    if (root.dataset.dvReady) return;
    root.dataset.dvReady = '1';
    const sheet = sheetFor(root);
    initReveal(root);
    initCardTracks(root);
    fitHeroTitle(root);
    initQuickAdd(root, sheet);
    initCollection(root);
    initProduct(root, sheet);
    initGuide(root);
    initDrawers(root);
  }

  initScrollLinks();
  const boot = () => document.querySelectorAll('.dv').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Re-inicia quando a seção é editada no personalizador do tema
  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll('.dv').forEach(init);
  });
})();
